import { getElementTag } from '@nrk/dh-server-libs/get-element-tag'
import TilpassetBilde from './components/tilpasset-bilde.js'

import './client.module.css'
import './components/tilpasset-bilde.module.css'
const tag = getElementTag(__APP_NAME__, __APP_VERSION__)

function safeDefine(elementName, constructor) {
  if (typeof customElements.get(elementName) === 'undefined') {
    customElements.define(elementName, constructor)
  }
}

export class AppElement extends HTMLElement {
  name = tag

  connectedCallback() {
    if (this.features.sanityIframePreview) {
      import('./preview/preview-iframe-api.ts' /* webpackChunkName: "dh-preview-iframe" */)
    }

    safeDefine('dh-tilpasset-bilde', TilpassetBilde)
  }

  get features() {
    return JSON.parse(this.getAttribute('features'))
  }
}

safeDefine(tag, AppElement)
